export type Lang = 'en' | 'fr' | 'da' | 'de';

export interface Category {
  slug: string;
  url: string;
  icon: string;
  image: string;
  name: Record<Lang, string>;
}

export const MAIN_SITE_URL = 'https://kaspreadsheet.com';

export const categories: Category[] = [
  {
    slug: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    image: 'https://readdy.ai/api/search-image?query=A%20crisp%20white%20leather%20sneaker%20with%20a%20sage%20green%20sole%20floating%20above%20a%20pale%20mint%20studio%20backdrop%20with%20soft%20daylight%2C%20single%20hero%20product%20shot%2C%20clean%20minimal%20commercial%20photography%2C%20subtle%20reflection%2C%20high%20detail%2C%20fresh%20airy%20aesthetic&width=600&height=600&seq=cat-shoes&orientation=squarish&nocache=true',
    name: { en: 'Shoes', fr: 'Chaussures', da: 'Sko', de: 'Schuhe' },
  },
  {
    slug: 'hoodies-sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=A%20folded%20oversized%20hoodie%20in%20soft%20terracotta%20orange%20lying%20on%20a%20blush%20pink%20textured%20linen%20background%20with%20gentle%20shadows%2C%20warm%20cozy%20editorial%20product%20photo%2C%20minimal%20styling%2C%20high%20detail%2C%20inviting%20modern%20aesthetic&width=600&height=600&seq=cat-hoodies&orientation=squarish&nocache=true',
    name: { en: 'Hoodies/Sweaters', fr: 'Hoodies/Sweats', da: 'Hoodies/Sweatere', de: 'Hoodies/Sweatshirts' },
  },
  {
    slug: 't-shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=A%20neatly%20folded%20bright%20white%20cotton%20t-shirt%20with%20a%20small%20coral%20graphic%20on%20a%20light%20grey%20concrete%20surface%2C%20flat%20lay%20product%20photography%2C%20crisp%20daylight%2C%20minimal%20clean%20styling%2C%20high%20detail%2C%20modern%20streetwear%20vibe&width=600&height=600&seq=cat-tshirts&orientation=squarish&nocache=true',
    name: { en: 'T-Shirts', fr: 'T-Shirts', da: 'T-shirts', de: 'T-Shirts' },
  },
  {
    slug: 'jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-contrast-drop-2-line',
    image: 'https://readdy.ai/api/search-image?query=A%20tailored%20camel%20wool%20jacket%20on%20a%20wooden%20hanger%20against%20a%20soft%20sage%20green%20wall%2C%20editorial%20fashion%20product%20photo%2C%20warm%20window%20light%2C%20minimal%20composition%2C%20high%20detail%2C%20premium%20clothing%20aesthetic&width=600&height=600&seq=cat-jackets&orientation=squarish&nocache=true',
    name: { en: 'Jackets', fr: 'Vestes', da: 'Jakker', de: 'Jacken' },
  },
  {
    slug: 'pants-shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-scissors-line',
    image: 'https://readdy.ai/api/search-image?query=A%20pair%20of%20neatly%20folded%20beige%20chino%20trousers%20with%20rolled%20cuffs%20on%20a%20warm%20sand%20wooden%20tabletop%2C%20flat%20lay%20fashion%20photo%2C%20soft%20natural%20light%2C%20minimal%20styling%2C%20high%20detail%2C%20clean%20modern%20aesthetic&width=600&height=600&seq=cat-pants&orientation=squarish&nocache=true',
    name: { en: 'Pants/Shorts', fr: 'Pantalons/Shorts', da: 'Bukser/Shorts', de: 'Hosen/Shorts' },
  },
  {
    slug: 'headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-user-star-line',
    image: 'https://readdy.ai/api/search-image?query=A%20structured%20olive%20green%20baseball%20cap%20and%20a%20cream%20knit%20beanie%20side%20by%20side%20on%20a%20soft%20white%20marble%20surface%2C%20top%20down%20product%20photo%2C%20soft%20studio%20light%2C%20minimal%20composition%2C%20high%20detail%2C%20fresh%20clean%20aesthetic&width=600&height=600&seq=cat-headwear&orientation=squarish&nocache=true',
    name: { en: 'Headwear', fr: 'Couvre-chefs', da: 'Hovedbeklædning', de: 'Kopfbedeckung' },
  },
  {
    slug: 'sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    image: 'https://readdy.ai/api/search-image?query=A%20matching%20two%20piece%20lounge%20set%20in%20soft%20lavender%20laid%20flat%20with%20a%20single%20dried%20flower%20on%20a%20warm%20ivory%20background%2C%20cozy%20editorial%20product%20photo%2C%20gentle%20shadows%2C%20high%20detail%2C%20calm%20minimal%20aesthetic&width=600&height=600&seq=cat-sets&orientation=squarish&nocache=true',
    name: { en: 'Sets', fr: 'Ensembles', da: 'Sæt', de: 'Sets' },
  },
  {
    slug: 'underwear',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-handbag-line',
    image: 'https://readdy.ai/api/search-image?query=Soft%20ribbed%20cotton%20briefs%20in%20muted%20grey%20and%20cream%20folded%20in%20a%20neat%20stack%20on%20a%20pale%20blue%20grey%20linen%20cloth%2C%20minimal%20intimate%20apparel%20product%20photo%2C%20soft%20diffused%20light%2C%20high%20detail%2C%20clean%20and%20gentle%20aesthetic&width=600&height=600&seq=cat-underwear&orientation=squarish&nocache=true',
    name: { en: 'Underwear/Underpants', fr: 'Sous-vêtements', da: 'Undertøj', de: 'Unterwäsche' },
  },
  {
    slug: 'jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-medal-line',
    image: 'https://readdy.ai/api/search-image?query=A%20deep%20green%20athletic%20jersey%20shirt%20with%20white%20trim%20hanging%20on%20a%20metal%20hanger%20against%20a%20light%20warm%20grey%20wall%2C%20sport%20editorial%20product%20photo%2C%20clean%20studio%20light%2C%20high%20detail%2C%20energetic%20minimal%20aesthetic&width=600&height=600&seq=cat-jersey&orientation=squarish&nocache=true',
    name: { en: 'Jersey', fr: 'Maillots', da: 'Trøjer', de: 'Trikots' },
  },
  {
    slug: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-vip-diamond-line',
    image: 'https://readdy.ai/api/search-image?query=A%20minimalist%20silver%20watch%20and%20a%20thin%20gold%20necklace%20arranged%20on%20a%20dark%20slate%20stone%20surface%2C%20moody%20luxury%20accessory%20product%20photo%2C%20soft%20dramatic%20lighting%2C%20high%20detail%2C%20premium%20refined%20aesthetic&width=600&height=600&seq=cat-accessories&orientation=squarish&nocache=true',
    name: { en: 'Accessories', fr: 'Accessoires', da: 'Tilbehør', de: 'Accessoires' },
  },
  {
    slug: 'bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-shopping-bag-line',
    image: 'https://readdy.ai/api/search-image?query=A%20structured%20tan%20leather%20handbag%20with%20gold%20hardware%20on%20a%20light%20oak%20wooden%20bench%2C%20warm%20editorial%20product%20photo%2C%20soft%20natural%20window%20light%2C%20minimal%20composition%2C%20high%20detail%2C%20timeless%20premium%20aesthetic&width=600&height=600&seq=cat-bags&orientation=squarish&nocache=true',
    name: { en: 'Bags', fr: 'Sacs', da: 'Tasker', de: 'Taschen' },
  },
  {
    slug: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    image: 'https://readdy.ai/api/search-image?query=Three%20leather%20belts%20in%20brown%20black%20and%20tan%20coiled%20into%20perfect%20loops%20on%20a%20warm%20cream%20canvas%20background%2C%20overhead%20product%20photo%2C%20soft%20even%20light%2C%20minimal%20styling%2C%20high%20detail%2C%20clean%20classic%20aesthetic&width=600&height=600&seq=cat-belts&orientation=squarish&nocache=true',
    name: { en: 'Belts', fr: 'Ceintures', da: 'Bælter', de: 'Gürtel' },
  },
  {
    slug: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    image: 'https://readdy.ai/api/search-image?query=An%20amber%20glass%20perfume%20bottle%20with%20a%20minimal%20label%20on%20a%20pale%20mint%20surface%20with%20a%20soft%20plant%20shadow%2C%20luxury%20fragrance%20product%20photo%2C%20bright%20airy%20light%2C%20high%20detail%2C%20elegant%20fresh%20aesthetic&width=600&height=600&seq=cat-perfumes&orientation=squarish&nocache=true',
    name: { en: 'Perfumes', fr: 'Parfums', da: 'Parfumer', de: 'Parfüms' },
  },
  {
    slug: 'other-stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-2-line',
    image: 'https://readdy.ai/api/search-image?query=A%20flat%20lay%20of%20assorted%20fashion%20accessories%20including%20sunglasses%20socks%20and%20a%20small%20pouch%20on%20a%20warm%20beige%20textured%20background%2C%20editorial%20product%20photo%2C%20soft%20natural%20light%2C%20high%20detail%2C%20playful%20minimal%20aesthetic&width=600&height=600&seq=cat-other&orientation=squarish&nocache=true',
    name: { en: 'Other Stuff', fr: 'Autres articles', da: 'Andre ting', de: 'Sonstiges' },
  },
];